"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_FIELD_META = void 0;
var INVOICE_FIELD_META = [
    { key: "name", label: "Invoice Name", group: "Basic" },
    { key: "invoiceType", label: "Invoice Type", group: "Basic" },
    { key: "isRecurring", label: "Recurring", group: "Basic" },
    { key: "requiresSlip", label: "Requires Slip", group: "Basic" },
    { key: "sendDay", label: "Send Day", group: "Schedule" },
    { key: "useDueAfterDays", label: "Use Due-After-Days", group: "Schedule" },
    { key: "dueAfterDays", label: "Days After Send", group: "Schedule" },
    { key: "specificDueDate", label: "Specific Due Date", group: "Schedule" },
    { key: "includesRental", label: "Includes Rental", group: "Cost Items" },
    { key: "includesRatesAndTaxes", label: "Includes Rates & Taxes", group: "Cost Items" },
    { key: "serviceIds", label: "Services", group: "Cost Items" },
    { key: "contactIds", label: "Contacts", group: "Cost Items" },
];
exports.INVOICE_FIELD_META = INVOICE_FIELD_META;
